import { Injectable } from '@angular/core';
import { TagTemplate } from 'src/app/_model/tag-template';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class TagTemplatesDaoService implements Resetable {
  abstract saveTagTemplates(tagTemplates: TagTemplate[]): Promise<void>;

  abstract reset(): Promise<void>;
  abstract clear(): Promise<void>;
}